/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a 260 nm absorbance reading into nucleic acid concentration (µg/mL, ng/µL).`)
};

const es_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte una lectura de absorbancia a 260 nm en concentración de ácido nucleico (µg/mL, ng/µL).`)
};

const de_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie eine Absorptionsmessung bei 260 nm in eine Nukleinsäurekonzentration um (µg/mL, ng/µL).`)
};

const nl_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een absorptiemeting bij 260 nm om naar nucleïnezuurconcentratie (µg/mL, ng/µL).`)
};

const fr_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez une lecture d'absorbance à 260 nm en concentration d'acide nucléique (µg/mL, ng/µL).`)
};

const it_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte una lettura di assorbanza a 260 nm in concentrazione di acido nucleico (µg/mL, ng/µL).`)
};

const pt_br2_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma leitura de absorbância a 260 nm em concentração de ácido nucleico (µg/mL, ng/µL).`)
};

const pt_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma leitura de absorvância a 260 nm em concentração de ácido nucleico (µg/mL, ng/µL).`)
};

const ja_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`260 nmの吸光度測定値を核酸濃度 (µg/mL、ng/µL) に変換します。`)
};

const zh_od_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 260 nm 吸光度读数转换为核酸浓度（µg/mL、ng/µL）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_tool_description", locale)
	if (locale === "en") return en_od_tool_description(inputs)
	if (locale === "es") return es_od_tool_description(inputs)
	if (locale === "de") return de_od_tool_description(inputs)
	if (locale === "nl") return nl_od_tool_description(inputs)
	if (locale === "fr") return fr_od_tool_description(inputs)
	if (locale === "it") return it_od_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_od_tool_description(inputs)
	if (locale === "pt") return pt_od_tool_description(inputs)
	if (locale === "ja") return ja_od_tool_description(inputs)
	return zh_od_tool_description(inputs)
};